import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import {TableHeader} from 'lib/ui/typography'
import {
  Broadcast,
  useBroadcasts,
} from 'organization/Event/Broadcasts/BroadcastsProvider'
import BroadcastRow from 'organization/Event/Broadcasts/BroadcastsTable/BroadcastRow'
import React, {useState} from 'react'
import {DragDropContext, Droppable, DropResult} from 'react-beautiful-dnd'
import styled from 'styled-components'
import SuccessAlert from 'lib/ui/alerts/SuccessAlert'

export default function BroadcastsTable() {
  const {broadcasts, setPositions} = useBroadcasts()
  const [successMessage, setSuccessMessage] = useState<string | null>(null)
  const handleDrag = useHandleDrag(broadcasts, setPositions)

  const hasBroadcasts = broadcasts.length > 0
  if (!hasBroadcasts) {
    return <p>No broadcasts have been added.</p>
  }

  return (
    <>
      <SuccessAlert onClose={() => setSuccessMessage(null)}>
        {successMessage}
      </SuccessAlert>
      <DragDropContext onDragEnd={handleDrag}>
        <StyledTable>
          <TableHead>
            <TableRow>
              <DateTableCell>
                <TableHeader>Date</TableHeader>
              </DateTableCell>
              <NameTableCell>
                <TableHeader>Name</TableHeader>
              </NameTableCell>
              <ChannelTableCell>
                <TableHeader>Channel</TableHeader>
              </ChannelTableCell>
              <SegmentTableCell>
                <TableHeader>Segments</TableHeader>
              </SegmentTableCell>
              <CenteredTableCell>
                <TableHeader>Send Status</TableHeader>
              </CenteredTableCell>
              <CenteredTableCell>
                <TableHeader>Published</TableHeader>
              </CenteredTableCell>
              <ActionTableCell>{/* Action Column */}</ActionTableCell>
            </TableRow>
          </TableHead>
          <Droppable droppableId="broadcasts">
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {broadcasts.map((broadcast, index) => (
                  <BroadcastRow
                    key={broadcast.id}
                    broadcast={broadcast}
                    index={index}
                    onSuccess={setSuccessMessage}
                  />
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </StyledTable>
      </DragDropContext>
    </>
  )
}

function useHandleDrag(
  broadcasts: Broadcast[],
  setPositions: (broadcasts: Broadcast[]) => void,
) {
  return (result: DropResult) => {
    const {destination, source} = result

    if (!destination) {
      return
    }

    const moved = Array.from(broadcasts)
    const [removed] = moved.splice(source.index, 1)
    moved.splice(destination.index, 0, removed)

    setPositions(moved)
  }
}

const StyledTable = styled(Table)`
  table-layout: fixed;
`

export const DateTableCell = styled(TableCell)`
  width: 14%;
`
export const NameTableCell = styled(TableCell)`
  width: 29%;
`
export const ChannelTableCell = styled(TableCell)`
  width: 12%;
`
export const SegmentTableCell = styled(TableCell)`
  width: 12%;
`
export const CenteredTableCell = styled(TableCell)`
  text-align: center;
  width: 9%;
`
export const ActionTableCell = styled(TableCell)`
  width: 15%;
`
